import { Button, Avatar, Divider, Cell, Swiper, Steps, Step, Popup } from '@nutui/nutui-react';
import { useMemo, useState } from "react";

import { bigNumberTransform } from '../common'

import jin from '../img/jin.png'
import yin from '../img/yin.png'
import tong from '../img/tong.png'
import jingtie from '../img/精铁.png'
import qianbi from '../img/金币.png'
import jinzhuan from '../img/金砖.png'
import jinjieshi from '../img/进阶石.png'

import 白玉 from '../img/白玉.png'
import 青铜宝箱 from '../img/青铜宝箱.png'
import 木质宝箱 from '../img/木质宝箱.png'
import 咸神门票 from '../img/咸神门票.png'
// import 随机红将碎片 from '../img/随机红将碎片.png'
// import 木材火把 from '../img/木材火把.png'
// import 随机紫将碎片 from '../img/随机紫将碎片.png'
// import 随机橙将碎片 from '../img/随机橙将碎片.png'
// import 随机红将碎片 from '../img/随机红将碎片.png'

import dayjs from 'dayjs';

function Home(props) {
    const { user = {} } = props;
    // const { encrypt_user } = user.config
    let { role_info: role = {}, daily_status, daily_rewards: dailyRewards, total_rewards: totalRewards } = user;

    // role.diamond  //金砖
    // role.hallEnergy  //客厅能量
    //
    // const list = [dailyRewards, totalRewards]
    const colStyle = { display: 'flex', alignItems: 'center', flexDirection: 'column', marginRight: '10px', marginLeft: '10px' }
    const [more, setMore] = useState(false)
    const [hangUpPage, setHangUpPage] = useState(1)
    const [bottlePage, setBottlePage] = useState(1)

    const dailyStatus = useMemo(() => {
        const updatedDailyStatus = daily_status.slice(1);
        updatedDailyStatus.reverse();
        // updatedDailyStatus = updatedDailyStatus.sort((item1, item2) => item2.time - item1.time)
        return updatedDailyStatus.map(item => {
            return { time: dayjs(item.time * 1e3).format('YYYY年MM月DD日 HH:mm:ss'), message: item.message }
        })
    }, [daily_status])

    const dailyLabel = useMemo(() => {
        if (!dailyRewards || !dailyRewards.time || dayjs().isSame(dailyRewards.time * 1000, 'date')) return "今日收益"
        return `${dayjs(dailyRewards.time * 1000).format('YYYY年MM月DD日')}收益`
    }, [dailyRewards])

    const yesterdayLabel = useMemo(() => {
        if (!dailyRewards?.lastDayRewards?.time) return "无昨日收益"
        if (dayjs().subtract(1, "day").isSame(dailyRewards.lastDayRewards.time * 1000, 'date')) return "昨日收益"
        return `${dayjs(dailyRewards.lastDayRewards.time * 1000).format('YYYY年MM月DD日')}收益`
    }, [dailyRewards])

    // console.log(dailyStatus)

    const bottleRewards = [
        {
            [`罐子 | ${dailyLabel}`]: {
                "金罐": dailyRewards?.金罐子 || 0,
                "银罐": dailyRewards?.银罐子 || 0,
                "铜罐": dailyRewards?.铜罐子 || 0,
                "金币": bigNumberTransform(dailyRewards["罐子:金币"] || 0),
                "金砖": dailyRewards?.["罐子:金砖"] || 0,
                "进阶石": dailyRewards?.["罐子:进阶石"] || 0,
                "精铁": dailyRewards?.["罐子:精铁"] || 0,
            }
        },
        {
            [`罐子 | ${yesterdayLabel}`]: {
                "金罐": dailyRewards?.lastDayRewards?.金罐子 || 0,
                "银罐": dailyRewards?.lastDayRewards?.银罐子 || 0,
                "铜罐": dailyRewards?.lastDayRewards?.铜罐子 || 0,
                "金币": bigNumberTransform(dailyRewards?.lastDayRewards?.["罐子:金币"] || 0),
                "金砖": dailyRewards?.lastDayRewards?.["罐子:金砖"] || 0,
                "进阶石": dailyRewards?.lastDayRewards?.["罐子:进阶石"] || 0,
                "精铁": dailyRewards?.lastDayRewards?.["罐子:精铁"] || 0,
            }
        },
        {
            "罐子 | 总收益": {
                "金罐": totalRewards?.金罐子 || 0,
                "银罐": totalRewards?.银罐子 || 0,
                "铜罐": totalRewards?.铜罐子 || 0,
                "金币": bigNumberTransform(totalRewards["罐子:金币"] || 0),
                "金砖": totalRewards?.["罐子:金砖"] || 0,
                "进阶石": totalRewards?.["罐子:进阶石"] || 0,
                "精铁": totalRewards?.["罐子:精铁"] || 0,
            }
        }
    ]

    const hangUpRewards = [
        {
            [`挂机 | ${dailyLabel}`]: {
                "木质宝箱": dailyRewards?.["挂机:木质宝箱"] || 0,
                "青铜宝箱": dailyRewards?.["挂机:青铜宝箱"] || 0,
                "梦魇晶石": dailyRewards?.["挂机:梦魇晶石"] || 0,
                "白玉": dailyRewards?.["挂机:白玉"] || 0,
                "金币": bigNumberTransform(dailyRewards["挂机:金币"] || 0),
                // "金币": bigNumberTransform(9999999999),
                "咸神门票": dailyRewards?.["挂机:咸神门票"] || 0,
                "进阶石": dailyRewards?.["挂机:进阶石"] || 0,
                "精铁": dailyRewards?.["挂机:精铁"] || 0,
                "随机红将碎片": dailyRewards?.["挂机:随机红将碎片"] || 0,
                "随机橙将碎片": dailyRewards?.["挂机:随机橙将碎片"] || 0,
                "随机紫将碎片": dailyRewards?.["挂机:随机紫将碎片"] || 0,
            }
        },
        {
            [`挂机 | ${yesterdayLabel}`]: {
                "木质宝箱": dailyRewards?.lastDayRewards?.["挂机:木质宝箱"] || 0,
                "青铜宝箱": dailyRewards?.lastDayRewards?.["挂机:青铜宝箱"] || 0,
                "梦魇晶石": dailyRewards?.lastDayRewards?.["挂机:梦魇晶石"] || 0,
                "白玉": dailyRewards?.lastDayRewards?.["挂机:白玉"] || 0,
                "金币": bigNumberTransform(dailyRewards?.lastDayRewards?.["挂机:金币"] || 0),
                "咸神门票": dailyRewards?.lastDayRewards?.["挂机:咸神门票"] || 0,
                "进阶石": dailyRewards?.lastDayRewards?.["挂机:进阶石"] || 0,
                "精铁": dailyRewards?.lastDayRewards?.["挂机:精铁"] || 0,
                "随机红将碎片": dailyRewards?.lastDayRewards?.["挂机:随机红将碎片"] || 0,
                "随机橙将碎片": dailyRewards?.lastDayRewards?.["挂机:随机橙将碎片"] || 0,
                "随机紫将碎片": dailyRewards?.lastDayRewards?.["挂机:随机紫将碎片"] || 0,
            }
        },
        {
            "挂机 | 总收益": {
                "木质宝箱": totalRewards?.["挂机:木质宝箱"] || 0,
                "青铜宝箱": totalRewards?.["挂机:青铜宝箱"] || 0,
                "梦魇晶石": totalRewards?.["挂机:梦魇晶石"] || 0,
                "白玉": totalRewards?.["挂机:白玉"] || 0,
                "金币": bigNumberTransform(totalRewards?.["挂机:金币"] || 0),
                "咸神门票": totalRewards?.["挂机:咸神门票"] || 0,
                "进阶石": totalRewards?.["挂机:进阶石"] || 0,
                "精铁": totalRewards?.["挂机:精铁"] || 0,
                "随机红将碎片": totalRewards?.["挂机:随机红将碎片"] || 0,
                "随机橙将碎片": totalRewards?.["挂机:随机橙将碎片"] || 0,
                "随机紫将碎片": totalRewards?.["挂机:随机紫将碎片"] || 0,
            }
        }
    ]

    return (
        <>






            <div className="demo-box" style={{ height: 165 }}>
                <Swiper
                    // autoPlay={3000}
                    // duration={1000}
                    loop={false}
                    onChange={page => setHangUpPage(page + 1)}
                    slideSize={window.innerWidth - 34}
                    indicator={<div className='swiper-page'> {hangUpPage}/3 </div>}
                    style={{
                        '--nutui-indicator-color': '#426543',
                        '--nutui-indicator-dot-color': '#426ddd',
                    }}
                >
                    {hangUpRewards.map((item, index) => {
                        const key = Object.keys(item)[0]
                        return (
                            <Swiper.Item key={key}>
                                <Divider>{key}</Divider>
                                <Cell style={{ flexDirection: 'column', paddingBottom: '10px' }} >
                                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                        <div style={colStyle}>
                                            <Avatar src={白玉} shape="square" size="small" />
                                            <div>{item[key].白玉}</div>
                                        </div>
                                        <div style={colStyle}>
                                            <Avatar src={木质宝箱} shape="square" size="small" />
                                            <div>{item[key].木质宝箱}</div>
                                        </div>
                                        <div style={colStyle}>
                                            <Avatar src={青铜宝箱} shape="square" size="small" />
                                            <div>{item[key].青铜宝箱}</div>
                                        </div>

                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                        <div style={colStyle}>
                                            <Avatar src={qianbi} shape="square" size="small" />
                                            <div>{item[key].金币}</div>
                                        </div>
                                        <div style={colStyle}>
                                            <Avatar src={咸神门票} shape="square" size="small" />
                                            <div>{item[key].咸神门票}</div>
                                        </div>


                                        <div style={colStyle}>
                                            <Avatar src={jinjieshi} shape="square" size="small" />
                                            <div>{item[key].进阶石}</div>
                                        </div>
                                        <div style={colStyle}>
                                            <Avatar src={jingtie} shape="square" size="small" />
                                            <div>{item[key].精铁}</div>
                                        </div>
                                        {/* <div style={colStyle}>
                                            <Avatar src={随机红将碎片} shape="square" size="small" />
                                            <div>{item[key].随机红将碎片}</div>
                                        </div>
                                        <div style={colStyle}>
                                            <Avatar src={随机橙将碎片} shape="square" size="small" />
                                            <div>{item[key].随机橙将碎片}</div>
                                        </div>
                                        <div style={colStyle}>
                                            <Avatar src={随机紫将碎片} shape="square" size="small" />
                                            <div>{item[key].随机紫将碎片}</div>
                                        </div> */}
                                    </div>
                                    {/* <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>

                                    </div> */}

                                </Cell>
                            </Swiper.Item>
                        )
                    })}
                </Swiper>
            </div>


            {!user.config.罐子.claim ?
                <>
                    <Divider>已囤罐子</Divider>
                    <Cell style={{ flexDirection: 'column' }} >
                        <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                            <div style={colStyle}>
                                <Avatar src={jin} shape="square" size="small" />
                                <div>{role?.bottleHelpers?.bottleHelper?.["0"]?.obtainCnt || 0}</div>
                            </div>
                            <div style={colStyle}>
                                <Avatar src={yin} shape="square" size="small" />
                                <div>{role?.bottleHelpers?.bottleHelper?.["1"]?.obtainCnt || 0}</div>
                            </div>
                            <div style={colStyle}>
                                <Avatar src={tong} shape="square" size="small" />
                                <div>{role?.bottleHelpers?.bottleHelper?.["2"]?.obtainCnt || 0}</div>
                            </div>
                        </div>
                    </Cell>
                </>
                :
                <div className="demo-box" style={{ height: 165 }}>
                <Swiper
                    // autoPlay={3000}
                    // duration={1000}
                    loop={false}
                    onChange={page => setBottlePage(page + 1)}
                    slideSize={window.innerWidth - 34}
                    // style={{ '--swiper-offset': '6%' }}
                    indicator={<div className='swiper-page'> {bottlePage}/3 </div>}
                    style={{
                        '--nutui-indicator-color': '#426543',
                        '--nutui-indicator-dot-color': '#426ddd',
                    }}
                >
                    {bottleRewards.map((item, index) => {
                        const key = Object.keys(item)[0]
                        return (
                            <Swiper.Item key={key}>
                                <Divider>{key}</Divider>
                                <Cell style={{ flexDirection: 'column' }} >
                                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                        <div style={colStyle}>
                                            <Avatar src={jin} shape="square" size="small" />
                                            <div>{item[key].金罐}</div>
                                        </div>
                                        <div style={colStyle}>
                                            <Avatar src={yin} shape="square" size="small" />
                                            <div>{item[key].银罐}</div>
                                        </div>
                                        <div style={colStyle}>
                                            <Avatar src={tong} shape="square" size="small" />
                                            <div>{item[key].铜罐}</div>
                                        </div>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                        <div style={colStyle}>
                                            <Avatar src={qianbi} shape="square" size="small" />
                                            <div>{item[key].金币}</div>
                                        </div>
                                        <div style={colStyle}>
                                            <Avatar src={jinzhuan} shape="square" size="small" />
                                            <div>{item[key].金砖}</div>
                                        </div>
                                        <div style={colStyle}>
                                            <Avatar src={jinjieshi} shape="square" size="small" />
                                            <div>{item[key].进阶石}</div>
                                        </div>
                                        <div style={colStyle}>
                                            <Avatar src={jingtie} shape="square" size="small" />
                                            <div>{item[key].精铁}</div>
                                        </div>

                                    </div>

                                </Cell>
                            </Swiper.Item>
                        )
                    })}
                </Swiper>
            </div> }

            {/* <Divider>罐子总收益</Divider>
            <Cell style={{ flexDirection: 'column' }} >
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={colStyle}>
                        <Avatar src={jin} shape="square" size="small" />
                        <div>{totalRewards?.金罐子 || 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={yin} shape="square" size="small" />
                        <div>{totalRewards?.银罐子 || 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={tong} shape="square" size="small" />
                        <div>{totalRewards?.铜罐子 || 0}</div>
                    </div>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={colStyle}>
                        <Avatar src={qianbi} shape="square" size="small" />
                        <div>{bigNumberTransform(totalRewards["罐子:金币"] || 0)}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={jinzhuan} shape="square" size="small" />
                        <div>{totalRewards["罐子:金砖"] || 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={jinjieshi} shape="square" size="small" />
                        <div>{totalRewards["罐子:进阶石"] || 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={jingtie} shape="square" size="small" />
                        <div>{totalRewards["罐子:精铁"] || 0}</div>
                    </div>

                </div>

            </Cell> */}
            {/* <Divider>{dailyLabel}</Divider>
            <Cell style={{ flexDirection: 'column' }} >
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={colStyle}>
                        <Avatar src={jin} shape="square" size="small" />
                        <div>{dailyRewards?.金罐子 || 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={yin} shape="square" size="small" />
                        <div>{dailyRewards?.银罐子 || 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={tong} shape="square" size="small" />
                        <div>{dailyRewards?.铜罐子 || 0}</div>
                    </div>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={colStyle}>
                        <Avatar src={qianbi} shape="square" size="small" />
                        <div>{bigNumberTransform(dailyRewards["罐子:金币"] || 0)}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={jinzhuan} shape="square" size="small" />
                        <div>{dailyRewards["罐子:金砖"] || 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={jinjieshi} shape="square" size="small" />
                        <div>{dailyRewards["罐子:进阶石"] || 0}</div>
                    </div>
                    <div style={colStyle}>
                        <Avatar src={jingtie} shape="square" size="small" />
                        <div>{dailyRewards["罐子:精铁"] || 0}</div>
                    </div>
                </div>

            </Cell> */}


            <Divider>操作日志</Divider>
            <Cell style={{ flexDirection: "column" }}>
                {
                    dailyStatus.length === 0 && <div style={{ padding: "15px", textAlign: "center" }}>无</div>
                }
                <Steps direction="vertical" value={0} dot >
                    {dailyStatus.map((item, index) => {
                        if (!more && index > 1) return <div></div>
                        return <Step
                            value={index}
                            title={item.time}
                            description={item.message}
                            style={{ marginBottom: "15px" }}
                        />
                    })}
                </Steps>
                <Button type="primary" onClick={() => setMore(!more)} style={{ width: '100%' }}>
                    查看更多
                </Button>
                {/* <div style={{ height: "50px" }} ></div> */}
            </Cell>
            <div style={{ height: "50px" }} ></div>
            <Popup
                closeable
                visible={more}
                style={{ height: '60%' }}
                position="bottom"
                onClose={() => setMore(!more)}
            >
                <Steps direction="vertical" value={0} dot style={{ paddingTop: "30px", paddingLeft: "30px" }}>
                    {dailyStatus.map((item, index) => {

                        return <Step
                            value={index}
                            title={item.time}
                            description={item.message}
                            style={{ marginBottom: "15px" }}
                        />
                    })}


                </Steps>
            </Popup>



        </>
    );
}

export default Home;